export const STATUS_LABEL = {
  DRAFT: 'Borrador',
  ACTIVE: 'En curso',
  CLOSED: 'Finalizada',
  ARCHIVED: 'Archivada',
} as const;

export const ATTENDANCE_LABEL = {
  NONE: 'No se exige asistencia',
  EVENT: 'Asistencia al evento',
  SESSION: 'Asistencia a la sesión',
  CHECKIN: 'Registro previo a la votación',
} as const;

export const KINDS_LABEL = {
  MINISTERS: 'solo ministros',
  GUESTS: 'solo invitados y delegados',
  BOTH: 'ministros, invitados y delegados',
} as const;

/** Why someone cannot vote (reasons raised by the eligibility rule) */
export const REASON_LABEL: Record<string, string> = {
  NOT_REGISTERED: 'No está registrado en esta elección.',
  REGISTRATION_REJECTED: 'Su inscripción fue rechazada.',
  KIND_NOT_ALLOWED: 'Este tipo de participante no vota en esta elección.',
  NOT_ENABLED: 'No está habilitado para votar.',
  NO_EVENT_ATTENDANCE: 'No registró asistencia al evento.',
  NO_SESSION_ATTENDANCE: 'No registró asistencia a la sesión de votación.',
  NOT_CHECKED_IN: 'Acérquese a la entrada para habilitar su voto.',
};

export const CHANNEL_LABEL = {
  KIOSK: 'en el kiosco',
  PUBLIC_LINK: 'desde su teléfono',
  ACCOUNT: 'con su cuenta',
} as const;

export const KIND_BADGE = { MINISTER: 'Ministro', GUEST: 'Invitado', DELEGATE: 'Delegado', MANUAL: 'Votante' } as const;
